module.exports = __webpack_public_path__ + "static/img/clause_confirmation101.6d2876d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_confirmation101.png
// module id = bTaC
// module chunks = 1